
    export default {
        name: "FiveStarProductsCardLayout",
        props: {
            data: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            insurerImg() {
                return this.data?.Logo?.url;
            },
            ctaLink() {
                return this.data?.ButtonLink;
            },
            remarkLink() {
                return this.data?.RemarkLink;
            },
            features() {
                const item = this.data
                return [item?.Feature1, item?.Feature2, item?.Feature3, item?.Feature4];
            }

        },
            
        methods: {
            iconCodeClassName(iconCode) {
                return `icon-${iconCode.toLowerCase()}`
            },
        }
    }
